import { render, staticRenderFns } from "./InsertEmoji.vue?vue&type=template&id=5f9bf077&scoped=true"
import script from "./InsertEmoji.vue?vue&type=script&lang=js"
export * from "./InsertEmoji.vue?vue&type=script&lang=js"
import style0 from "./InsertEmoji.vue?vue&type=style&index=0&id=5f9bf077&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9bf077",
  null
  
)

export default component.exports